import { inject, observer } from "mobx-react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import ManufacturePackagingListStore, {
    ManufacturePackagingListRowData,
    PackingListSummaryWorks
} from "../../../../data/store/pageStore/manufacture/ManufacturePackagingListStore";
import { useEffect, useState } from "react";
import { IRootStore } from "../../../../data/store/RootStore";
import {
    Checkbox,
    Container,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography
} from "@material-ui/core";
import React from "react";
import ManufacturePackagingListPrintComponent from "../../task/manufacture/component/ManufacturePackagingListPrintComponent";

type Props = IRootStore & RouteComponentProps<any> & {};

type RowProps = {
    data: ManufacturePackagingListRowData;
};

const joinByNewLine = (list?: (string | undefined)[]) => {
    return list?.filter(Boolean).join('\n');
};

const MergedByErpCode = (works?: PackingListSummaryWorks[]) => {
    if (!works) return null;

    const ws: PackingListSummaryWorks[] = [];
    let current = '';

    for (const w of works) {
        if (w.erpCode !== current) {
            ws.push(w);
            current = w.erpCode ?? '';
        }
    }

    return (
        <>
            <TableCell>
                {joinByNewLine(ws.map(v => v.shippingDateStr))}
            </TableCell>
            <TableCell>
                {joinByNewLine(ws.map(v => v.erpCode))}
            </TableCell>
            <TableCell>
                {joinByNewLine(ws.map(v => v.salesRepresentativeObj.name))}
            </TableCell>
            <TableCell>
                {joinByNewLine(ws.map(v => v.customerAndPI))}
            </TableCell>
        </>
    );
};

const ManufacturePackagingListRow = observer(({ data }: RowProps) => {
    return (
        <TableRow>
            <TableCell padding='checkbox'>
                <Checkbox
                    onClick={(e: any) => {
                        data.isSelected = e.target.checked;
                    }}
                    checked={data.isSelected}
                />
            </TableCell>

            <TableCell>{data.index}</TableCell>
            <TableCell>{data.boxNO}</TableCell>

            {MergedByErpCode(data.works)}
        </TableRow>
    );
});

const store = new ManufacturePackagingListStore();

const ManufacturePackagingListPage = inject('rootStore')(observer((props: Props) => {
    const globalStore = props.rootStore.globalStore;
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        globalStore.currentTaskTitle = "Packaging List";
        store.setPackagingListData(globalStore.token);
        setIsLoaded(true);
    }, [globalStore.token, globalStore]);

    return (
        <React.Fragment>
            <Container maxWidth='xl'>
                <Grid container direction='column' alignItems='stretch'>
                    <Grid item xl lg sm style={{ whiteSpace: 'pre-line', padding: 5 }}></Grid>

                    <Grid item xl lg sm>
                        <Paper style={{ padding: 30 }}>
                            <ManufacturePackagingListPrintComponent
                                data={store.data}
                                isLoaded={isLoaded}
                            />
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell padding='checkbox'>
                                            <Checkbox
                                                onClick={(e: any) =>
                                                    store.selectAll(e.target.checked)
                                                }
                                                indeterminate={
                                                    store.numSelected > 0 &&
                                                    store.numSelected < (store.data?.length ?? 0)
                                                }
                                                checked={
                                                    store.numSelected === store.data?.length
                                                }
                                            />
                                        </TableCell>

                                        <TableCell>
                                            <Typography variant='subtitle1'>
                                                <strong>#</strong>
                                            </Typography>
                                        </TableCell>

                                        <TableCell>
                                            <Typography variant='subtitle1'>
                                                <strong>Box No.</strong>
                                            </Typography>
                                        </TableCell>

                                        <TableCell>
                                            <Typography variant='subtitle1'>
                                                <strong>출하 요청일</strong>
                                            </Typography>
                                        </TableCell>

                                        <TableCell>
                                            <Typography variant='subtitle1'>
                                                <strong>ERP Code</strong>
                                            </Typography>
                                        </TableCell>

                                        <TableCell>
                                            <Typography variant='subtitle1'>
                                                <strong>담당자</strong>
                                            </Typography>
                                        </TableCell>

                                        <TableCell>
                                            <Typography variant='subtitle1'>
                                                <strong>고객 & PI</strong>
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {store.data?.map((v, i) => (
                                        <ManufacturePackagingListRow
                                            key={`listData${i}`}
                                            data={v}
                                        />
                                    ))}
                                </TableBody>
                            </Table>
                        </Paper>
                    </Grid>
                </Grid>
            </Container>
        </React.Fragment>
    );
}));

export default withRouter(ManufacturePackagingListPage);
